import cloneDeep from 'lodash/cloneDeep';
import baseDefaults from '../Base/Base.defaults';
import baseTextDefaults from '../BaseText/BaseText.defaults';

export default {
  ...cloneDeep(baseDefaults),
  alignment: 'left',
  beforeText: 'Converdy is perfect for',
  afterText: '',
  cursor: '_',
  typerText: cloneDeep(baseTextDefaults),
  items: [],
  tagName: 'h1',
  title: cloneDeep(baseTextDefaults),
};
